import { Endpoint } from '../endpoint';
import { ProgramResponse, ProgramId, ProgramSectionResponse, SectionId, ProgramSectionSortingResponse } from '@business/entities/programs';

export function fetchSections(id: ProgramId) {
  return Endpoint.get<ProgramSectionResponse[]>(`@makh/program-sections/program-sections/${id}`);
}

export function createProgramSection(data: Partial<ProgramSectionResponse>) {
  return Endpoint.post<ProgramSectionResponse>(`@makh/program-sections`, { data });
}

export function deleteProgramSection(id: SectionId) {
  return Endpoint.delete<void>(`@makh/program-sections/${id}`);
}

export function selectOneSection(sectionId: SectionId) {
  return Endpoint.get<ProgramSectionResponse>(`@makh/program-sections/program-section/${sectionId}`);
}

export function updateProgramSection(sectionId: SectionId, data: Partial<ProgramSectionResponse>) {
  return Endpoint.patch<ProgramSectionResponse>(`@makh/program-sections/${sectionId}`, { data });
}

export function sortProgramSection(section: ProgramSectionResponse, fromPosition: any, toPosition: number, programId: ProgramId) {
  return Endpoint.post<ProgramSectionResponse[]>(`@makh/program-sections/sort-program-sections`, {
    data: { section, fromPosition, toPosition, programId },
  });
}

export function sortTargets(programId: ProgramId, section: ProgramSectionSortingResponse[]) {
  return Endpoint.post<ProgramSectionResponse[]>(`@makh/program-sections/sort-program-sections-targets`, { data: { programId, section } });
}
